module.exports = __webpack_public_path__ + "media/images/official/ribbon_otoku-b0960c21b9127936e631657f11b42c33.svg";